import store from '@/store/store'

export default function retailerForwardSaleBlocker(to, from, next) {
  if (store.getters['retailerAuth/isDemo']) {
    next()
    return
  }

  if (store.getters['retailerAuth/forwardSalesChannelStatus'] || store.getters['retailerAuth/virtualPosSalesChannelStatus']) {
    next()
    return
  }

  next({
    name: 'retailer.information'
  })
}
